import { FilterTypes } from './filter_types';
import { CheckboxValues } from './checkbox_values';

const FilterTypeDefaultValues = {
    [FilterTypes.BOOLEAN_FILTER]: CheckboxValues.OFF,
    [FilterTypes.OPTION_FILTER]: '',
    [FilterTypes.INPUT_FILTER]: '',
    [FilterTypes.PRICE_FILTER]: '0',
    [FilterTypes.NUMBER_FILTER]: 0,
};

export { FilterTypeDefaultValues };